﻿import CookieManager from './lib/gdpr-cookie';

document.addEventListener('DOMContentLoaded', () => new CookieManager());